import { render } from "./ProductFavourites.vue?vue&type=template&id=02cd6e61&scoped=true"
import script from "./ProductFavourites.vue?vue&type=script&lang=js"
export * from "./ProductFavourites.vue?vue&type=script&lang=js"

import "./ProductFavourites.vue?vue&type=style&index=0&id=02cd6e61&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02cd6e61"]])

export default __exports__